
import React, { useState } from "react";
import "./ReadyToBusiness.css";
import { Button } from "@mui/material";
import ContactFormModal from "../ContactFormModal/ContactFormModal"; 

function ReadyToBusinessWithModal() {
  const [openForm, setOpenForm] = useState(false);

  return (
    <div className="rtbMn">
      <div className="maxW">
        <h3>Let's get in touch</h3>

        <div className="rtbCon">
          <div className="rtbLft">
            <h2>
              Ready to do business with
              <br />
              the experts at PAYTECH ADVISOR?
            </h2>
          </div>

          <div className="rtbRyt">
            <Button variant="contained" onClick={() => setOpenForm(true)}>
              Let’s Talk
            </Button>

            <Button variant="outlined" component="a" href="/contact-us">
              Contact Us
            </Button>
          </div>
        </div>
      </div>

    
      <ContactFormModal open={openForm} onClose={() => setOpenForm(false)} />
    </div>
  );
}

export default ReadyToBusinessWithModal;
